import { Breadcrumbs } from '../components/Breadcrumbs'
import { LINKS } from '../config/links'
import { Seo } from '../seo/Seo'
import { breadcrumbSchema } from '../seo/schema'
import './Legal.css'

export function Terms() {
  return (
    <main className="legal">
      <Seo
        title="Terms of Use"
        description="Terms of use for Music24 Jewish music radio apps and website."
        path="/terms"
        jsonLd={breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Terms', path: '/terms' },
        ])}
      />
      <Breadcrumbs
        items={[
          { name: 'Home', path: '/' },
          { name: 'Terms' },
        ]}
      />
      <h1>Terms of Use</h1>
      <p className="legal__updated">Last updated: August 3, 2026</p>

      <section>
        <h2>Agreement</h2>
        <p>
          By using Music24’s apps or website, you agree to these Terms of Use.
          If you do not agree, please do not use the service.
        </p>
      </section>

      <section>
        <h2>The service</h2>
        <p>
          Music24 provides live radio-style streams of Jewish music for personal,
          non-commercial listening. Features, stations, and availability may
          change over time.
        </p>
      </section>

      <section>
        <h2>Acceptable use</h2>
        <p>
          You may not misuse the service, attempt to disrupt streams, scrape or
          redistribute content, or use Music24 in any way that violates law or
          the rights of others.
        </p>
      </section>

      <section>
        <h2>Intellectual property</h2>
        <p>
          Music24 branding, design, and software are owned by us or our
          licensors. Streamed music remains the property of its rights holders.
        </p>
      </section>

      <section>
        <h2>Disclaimer</h2>
        <p>
          The service is provided “as is.” We do not guarantee uninterrupted
          availability, and we are not liable for indirect or consequential
          damages arising from your use of Music24 to the fullest extent
          permitted by law.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          Questions about these terms? Email{' '}
          <a href={`mailto:${LINKS.supportEmail}`}>{LINKS.supportEmail}</a>.
        </p>
      </section>
    </main>
  )
}
